import moment from 'moment'

export function filterEvents (events, filters) {
  let filteredFirstPass = []
  let filteredSecondPass = []
  let filteredEvents = []
  const detectables = filters ? filters.detectables : []
  const cameras = filters ? filters.cameras : []
  const cameraTags = filters ? filters.cameraTags : []
  // if only one filter selected, filter inclusively - i.e. all alerts that that detectable even if they also have other detectables)
  if (detectables && detectables.length === 1) {
    filteredFirstPass = events.filter(event => {
      let eventTags = new Set(event.className.split(','))
      return eventTags.has(detectables[0])
    })
  } else if (detectables && detectables.length > 1) {
    // if more than one filter is selected, filter exclusively - i.e. only show alerts that match those tags
    filteredFirstPass = events.filter(event => {
      let eventTags = event.className.split(',')
      // check whether eventTags is a subset of detectables
      return detectables.every(detectable => eventTags.includes(detectable))
    })
  } else {
    filteredFirstPass = events
  }

  if (cameraTags && cameraTags.length > 0) {
    filteredSecondPass = filteredFirstPass.filter(event => {
      return event.cameraTags && Object.keys(event.cameraTags).some(tag => cameraTags.includes(tag))
    })
  } else {
    filteredSecondPass = filteredFirstPass
  }

  // OR filters
  if (cameras && cameras.length >= 1) {
    filteredEvents = filteredSecondPass.filter(event => {
      return cameras.includes(event.cameraId)
    })
  } else {
    filteredEvents = filteredSecondPass
  }

  return filteredEvents
}

export function parseEventsByDay (events) {
  const dayCards = {}

  events.map(event => {
    let timestamp = moment(event.timestamp).format('dddd, MMMM DD, YYYY')
    dayCards[timestamp] = dayCards[timestamp] || []
    dayCards[timestamp].push(event)
  })

  return dayCards
}

export function deduplicateEvents (events) {
  let seen = new Set([])
  return events.filter(event => {
    const isDuplicate = seen.has(event.id)
    seen.add(event.id)
    return !isDuplicate
  })
}
